// Typelizer digest 1540c2ca24ad740873b592ef14379e1f
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/relief/bookings */
  index: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/relief/bookings', params, options),
    method: 'get',
  }),
}
